import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useSupports } = getCRUDHooks({
  entityName: 'userSupports',
  find: ({ userId, filters }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).supports.find(filters),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useSupports,
};
